import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getHelpCenterTopBarSplitFlag, getThemeColor } from 'state/selectors/help-center';
import { HelpCenterAnnouncement } from './help-center-announcement';

const selector = createSelector(getThemeColor, getHelpCenterTopBarSplitFlag, (themeColor, hasTopBarBeenSplit) => ({
    themeColor,
    hasTopBarBeenSplit,
}));

export default connect(selector, {})(HelpCenterAnnouncement);
